import React, { useState } from "react";
import styles from "./EnrollmentConfirmModal.scss";
import Modal from "components/common/Modal/Modal";
import SignatureBox from "components/common/SignatureBox";
import CheckboxInput from "components/common/CheckboxInput";

export default function EnrollmentConfirmModal({
    show,
    onClose,
    onConfirm,
    clinic,
    isFinalizingEarly,
    enrolledClinicCount,
    updateStatusAction,
}) {
    const [isChecked, setIsChecked] = useState(false);
    const [signature, setSignature] = useState('');


    function createDataObject({ signature, formFields, status }) {
        return {
          signature,
          acceptedTerms: true,
          formFieldsJson: JSON.stringify(formFields),
          status,
          systemEnrolled: false
        };
      }

    const handleConfirm = () => {
        if (!isFinalizingEarly && !isChecked) {
            alert("Please check the box before confirming.");
            return;
        }
        if (!isFinalizingEarly && !signature.trim()) {
            alert("Please provide your signature before confirming.");
            return;
        }

        const data = createDataObject({
            signature: signature,
            formFields: null,
            status: 'Enroll'
          });

        if (isFinalizingEarly) {
            onConfirm(data, true);
            onClose();
        } else {
            updateStatusAction(clinic.clinicId, 30, data)
                .then(() => {
                    onConfirm(data);
                    onClose();
                })
                .catch((error) => {
                    console.error("Error confirming enrollment:", error);
                    alert("An error occurred while confirming enrollment. Please try again.");
                });
        }
    };

    const renderFinalizingEarlyContent = () => (
        <div className={styles.modalTextContainer}>
            <div>Are you sure you want to finalize enrollment early?</div>
            <div>This action will lock your current selections and cannot be undone.</div>
        </div>
    );

    const renderRegularEnrollmentContent = () => (
        <>
            <div className={styles.modalTextContainer}>
                <div>Once you enroll this clinic, the selection cannot be changed.</div>
                <div>You may enroll up to four clinics, and this will count as one of them.</div>
                <div>After confirming your enrollment below, Greenline customer service will contact your
                clinic within 24 hours to set up the Forever Feline offer.</div>
            </div>
            <div className={styles.checkboxContainer}>
                <CheckboxInput
                    onChange={() => setIsChecked(!isChecked)}
                    name="confirmEnrollment"
                    checked={isChecked}
                />
                I understand that this enrollment is final and cannot be undone.
            </div>
            <div className={styles.signatureContainer}>
                <SignatureBox
                    onChange={(e) => setSignature(e.value)}
                    name="signature"
                    label="Please Sign Here"
                    value={signature}
                    autoFocus
                />
            </div>
        </>
    );

    return (
        <Modal
            show={show}
            onClose={onClose}
            modalTitle={
                isFinalizingEarly
                    ? `Finalize Enrollment for ${enrolledClinicCount} clinic${enrolledClinicCount > 1 ? 's' : ''}?`
                    : clinic
                        ? `Confirm Enrollment for ${clinic.clinicName}?`
                        : "Confirm Enrollment"
            }
            modalStyle="confirm"
            small>
            <div className={styles.modalContent}>
                {isFinalizingEarly ? renderFinalizingEarlyContent() : renderRegularEnrollmentContent()}
                <div className={styles.buttonContainer}>
                    <button onClick={onClose} className={styles.cancelButton}>
                        Cancel
                    </button>
                    <button
                        onClick={handleConfirm}
                        className={styles.confirmButton}
                        disabled={!isFinalizingEarly && (!isChecked || !signature.trim())}
                    >
                        Confirm
                    </button>
                </div>
            </div>
        </Modal>
    );
}